import { IdName } from '../../../shared/models';

export class CustomerPurchasesSummary {
    customerId: number;
    firstName: string;
    lastName: string;
    location: IdName;
    invoiceCount: number;
    amountSpent: number;
    lastInvoiceDate: string;

    constructor(summary: any) {
        Object.assign(this, summary);
    }

    get fullName() {
        return `${this.firstName} ${this.lastName}`;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/customers/shared/models/customer-purchases-summary.ts